var React = require('react');

function MinusIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.5 8H14.5","stroke":"currentColor","strokeWidth":"2.5","strokeLinecap":"round"}));
}

MinusIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = MinusIcon;

MinusIcon.default = MinusIcon;
